
import {
  defineComponent, computed, PropType, onMounted, nextTick,
  ref,
} from '@vue/composition-api';
import { storyBlokCompResp } from '~/selectors/types';
import { getAngieUIComponent } from '~/selectors/selectorsMap';
import { isMobileEffect } from '~/effects/matchMedia';
// @ts-ignore
import * as colors from '@fc/angie-ui/dist/styles/_js_exports.scss';

export default defineComponent({
  name: 'ResponsiveRow',
  inheritAttrs: false,
  props: {
    contentContainer: {
      type: Array as PropType<storyBlokCompResp[]>,
      required: true,
    },
    columnsDesktop: {
      type: String,
      default: '3',
    },
    columnsMobile: {
      type: String,
      default: '1',
    },
    isCarouselInMobile: {
      type: Boolean,
      default: false,
    },
    // It's good practice to have a screenLabel for accessibility on the carousel
    carouselScreenLabel: {
      type: String,
      default: 'Interactive Content Row',
    },
    carouselEffect: {
      type: String,
      default: 'slide',
    },
    arrowColor: {
      type: String,
      default: '#fff',
    },
  },
  setup(props, context) {
    const columnsDesktop = computed(() => props.columnsDesktop);
    const columnsMobile = computed(() => props.columnsMobile);

    const getCardStyle = computed(() => ({
      '--columns-desktop': columnsDesktop.value,
      '--columns-mobile': columnsMobile.value,
    }));

    const getProps = (comp: storyBlokCompResp) => {
      if (comp?.component === 'Experiment') {
        const typedComp = comp as any;
        return { body: typedComp.body, growthbook: typedComp.growthbook };
      }
      return getAngieUIComponent(comp?.component, comp) ?? comp;
    };

    const components = computed(() => props.contentContainer.map((comp, index) => ({
      ...getProps(comp),
      _key: comp._uid || `comp-${Math.random().toString(36).substring(2, 9)}`,
      slideScreenLabel: `${comp.component}_${index}` || 'Slide Content',
    })));

    const isMobileView = isMobileEffect();
    const shouldUseCarousel = computed(() => props.isCarouselInMobile && isMobileView.value);
    const swiperThemeStyle = computed(() => ({
      '--swiper-navigation-color': colors[props.arrowColor] ?? '#fff',
      '--swiper-navigation-sides-offset': '0px',
      '--swiper-navigation-size': isMobileView.value ? '23px' : '40px',
      width: props.carouselEffect === 'cards' ? '80%' : 'auto',
    }));

    // @ts-ignore
    const { $ecommAnalytics } = useNuxtApp();
    const swiperContainerRef = ref<any>(null);
    const elementId = computed(() => props.carouselScreenLabel?.trim() || `carousel-${context.attrs._uid}`);
    onMounted(async () => {
      await nextTick(); // since it's a client-only component, ensures DOM is ready
      const swiperEl = swiperContainerRef.value;
      console.log('swiperEl', swiperEl);
      if (!swiperEl) return;

      swiperEl.addEventListener('swiperslidechangetransitionend', (event: any) => {
        const swiper = event.detail[0];
        console.log('tracking carousel slide change', {
          carousel_slide_index: swiper.realIndex,
          carousel_name: elementId.value,
        });
        $ecommAnalytics.trackEvent('carousel_slide_change', {
          carousel_slide_index: swiper.realIndex,
          carousel_name: elementId.value,
        });
      });
    });

    return {
      swiperContainerRef,
      elementId,
      getCardStyle,
      components,
      shouldUseCarousel,
      swiperThemeStyle,
      isCarouselSlide: computed(() => props.carouselEffect === 'slide'),
    };
  },
});
